import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboard__section" }
const _hoisted_2 = { class: "dashboard__section-title" }
const _hoisted_3 = { class: "download__info" }
const _hoisted_4 = { class: "download__info-item" }
const _hoisted_5 = { class: "download__info-item" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", null, "Release Notes", -1)
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "download__buttons" }
const _hoisted_9 = { class: "download__button-container" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Download ")
const _hoisted_11 = { class: "download__button-container" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" View on GitHub ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_external_anchor = _resolveComponent("external-anchor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.release.name), 1),
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", _hoisted_4, [
        _createVNode(_component_fa_icon, { icon: ['far', 'tag'] }),
        _createTextVNode(" " + _toDisplayString(_ctx.release.tag), 1)
      ]),
      _createElementVNode("li", _hoisted_5, [
        _createVNode(_component_fa_icon, { icon: ['far', 'clock'] }),
        _createTextVNode(" " + _toDisplayString(_ctx.formattedDate), 1)
      ])
    ]),
    _hoisted_6,
    _createElementVNode("div", {
      innerHTML: _ctx.release.bodyHtml
    }, null, 8, _hoisted_7),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", _hoisted_9, [
        _createVNode(_component_external_anchor, {
          class: "download__button button--inverted",
          href: _ctx.release.assetUri,
          "show-icon": false
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _createVNode(_component_fa_icon, { icon: ['far', 'arrow-down'] })
          ]),
          _: 1
        }, 8, ["href"])
      ]),
      _createElementVNode("span", _hoisted_11, [
        _createVNode(_component_external_anchor, {
          class: "download__github-button button--no-bg",
          href: _ctx.release.repositoryUri,
          "show-icon": false
        }, {
          default: _withCtx(() => [
            _hoisted_12,
            _createVNode(_component_fa_icon, { icon: ['fab', 'github'] })
          ]),
          _: 1
        }, 8, ["href"])
      ])
    ])
  ]))
}